import { component } from 'picoapp';

export default component(async (node) => {
  let rect = node.getBoundingClientRect();
  const slider = node.querySelector('[data-slider]');
  const separator = node.querySelector('[data-separator]');
  const leftImage = slider.querySelector('img');
  let currentPosition = 50;

  const resizeObserver = new ResizeObserver(() => {
    rect = node.getBoundingClientRect();

    leftImage.style.width = `${rect.width}px`;
  });
  resizeObserver.observe(node);

  const moveSeparator = (percent) => {
    currentPosition = Math.min(percent, 100);
    currentPosition = Math.max(currentPosition, 0);

    slider.style.width = `${currentPosition}%`;
    separator.style.left = `${currentPosition}%`;
  };

  const calculatePlacement = (clientX) => {
    const x = clientX - rect.left;

    return (x / rect.width) * 100;
  };

  node.addEventListener('mousemove', (event) => {
    if (event.buttons !== 1 && event.buttons !== 3) {
      return;
    }

    node.focus();
    moveSeparator(calculatePlacement(event.clientX || event.pageX));
  });

  node.addEventListener('touchmove', (event) => {
    node.focus();

    const touch = event.touches[0];
    moveSeparator(calculatePlacement(touch.clientX || touch.pageX));
  });

  node.addEventListener('keydown', (event) => {
    // eslint-disable-next-line default-case
    switch (event.key) {
      case 'ArrowLeft':
        moveSeparator(currentPosition - 5);
        break;

      case 'ArrowRight':
        moveSeparator(currentPosition + 5);
        break;
    }
  });
});
